

export function subprogramStatusStyle(){
  return {
    "draft": {
      'background': '#999999',
      'color': 'white'
    },
    "published": {
      'background': '#2ACC73',
      'color': 'white'
    },
    "regOpened": {
      'background': '#FFCD07',
      'color': 'white'
    },
    "regClosed": {
      'background': '#EE7266',
      'color': 'white'
    },
    "archived": {
      'background': '#CCCCCC',
      'color': 'white'
    },
  }
}
// export function propertyStatusTagType(status){
//   if (!status || status === subprogramStatus.ENABLE) {
//     return 'success'
//   }
//   if (!status || status === subprogramStatus.DISABLE) {
//     return 'danger'
//   }
// }
export default subprogramStatusStyle;